const API_BASE_URL = (process.env.VUE_APP_URL || 'http://localhost:3000').replace(/\/+$/, '')

function getAuthHeaders() {
  const token = JSON.parse(localStorage.getItem('access_token'))
  const headers = {
    'Content-Type': 'application/json',
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

function handleResponse(response) {
  if (!response.ok) {
    return response.json().then(err => {
      throw err
    })
  }
  return response.json()
}

async function safeFetch(input, init) {
  try {
    const res = await fetch(input, init)
    return handleResponse(res)
  } catch (err) {
    const url = (input && input.href) || input || ''
    console.error('[complianceApi] Network fetch failed for', url, err)
    throw { error: 'Network Error', message: `Failed to fetch ${url}: ${err?.message || err}` }
  }
}

export const complianceApi = {
  listDocuments: (params) => {
    const url = new URL(API_BASE_URL + '/compliance')
    if (params) Object.keys(params).forEach(key => {
      const v = params[key]
      if (v !== undefined && v !== null && v !== '') url.searchParams.append(key, params[key])
    })
    return safeFetch(url, {
      headers: getAuthHeaders(),
    })
  },

  createDocument: (payload) => {
    return safeFetch(`${API_BASE_URL}/compliance`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    })
  },

  updateDocument: (id, payload) => {
    return safeFetch(`${API_BASE_URL}/compliance/${id}`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    })
  },

  deleteDocument: (id) => {
    return safeFetch(`${API_BASE_URL}/compliance/${id}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    })
  },
}

export { API_BASE_URL }
export default complianceApi
